module.exports = __webpack_public_path__ + "img/carrito-compra.09460b83.svg";